"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.kmh2kts = exports.kmh2mph = exports.kmh2ms = exports.kts2mph = exports.kts2kmh = exports.kts2ms = exports.mph2kmh = exports.mph2kts = exports.mph2ms = exports.ms2kmh = exports.ms2mph = exports.ms2kts = void 0;
var rounding_1 = require("./rounding");
var DEF_PRECISION = 2;
/* ***  FROM M/S  *** */
// ms -> kts
var ms2kts = function (val, decimals) { return rounding_1.default(val * 1.9438, decimals || DEF_PRECISION); };
exports.ms2kts = ms2kts;
// ms -> mph
var ms2mph = function (val, decimals) { return rounding_1.default(val * 2.2369, decimals || DEF_PRECISION); };
exports.ms2mph = ms2mph;
// ms -> kmh
var ms2kmh = function (val, decimals) { return rounding_1.default(val * 3.6, decimals || DEF_PRECISION); };
exports.ms2kmh = ms2kmh;
/* ***  FROM MPH  *** */
// mph -> ms
var mph2ms = function (val, decimals) { return rounding_1.default(val * 0.447, decimals || DEF_PRECISION); };
exports.mph2ms = mph2ms;
// mph -> knots
var mph2kts = function (val, decimals) { return exports.ms2kts(exports.mph2ms(val, decimals), decimals); };
exports.mph2kts = mph2kts;
// mph -> kmh
var mph2kmh = function (val, decimals) { return exports.ms2kmh(exports.mph2ms(val, decimals), decimals); };
exports.mph2kmh = mph2kmh;
/* ***  FROM KNOTS  *** */
// knots -> ms
var kts2ms = function (val, decimals) { return rounding_1.default(val * 0.5143, decimals || DEF_PRECISION); };
exports.kts2ms = kts2ms;
// knots -> kmh
var kts2kmh = function (val, decimals) { return exports.ms2kmh(exports.kts2ms(val, decimals), decimals); };
exports.kts2kmh = kts2kmh;
// knots -> mph
var kts2mph = function (val, decimals) { return exports.ms2mph(exports.kts2ms(val, decimals), decimals); };
exports.kts2mph = kts2mph;
/* ***  FROM KM/H  *** */
// kmh -> ms
var kmh2ms = function (val, decimals) { return rounding_1.default(val * 0.2778, decimals || DEF_PRECISION); };
exports.kmh2ms = kmh2ms;
// kmh -> mph
var kmh2mph = function (val, decimals) { return exports.ms2mph(exports.kmh2ms(val, decimals), decimals); };
exports.kmh2mph = kmh2mph;
// kmh -> knots
var kmh2kts = function (val, decimals) { return exports.ms2kts(exports.kmh2ms(val, decimals), decimals); };
exports.kmh2kts = kmh2kts;
